export default __webpack_public_path__ + "static/media/favicon-192x192.bc946f87.png";